<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <!-- Table Header -->
        <div class="card-header pb-0">
          <slot name="headerTable" />
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="mb-0">{{ title }}</h6>
            <div class="d-flex mb-2">
              <argon-button
                class="float-end"
                @click="$emit('open-modal')"
                color="success"
                size="md"
                variant="gradient"
                ><i class="fas fa-plus"></i> {{ buttonTitle }}</argon-button
              >
            </div>
          </div>
        </div>
        <!-- Table Body -->
        <div class="card-body px-0 pb-2">
          <div class="container-fluid">
            <div class="d-flex justify-content-between align-items-center">
              <slot name="filtersInputs" />
              <div class="col-3">
                <el-select
                  class="form-control"
                  v-model="size"
                  placeholder="Page Size"
                  @change="(value) => $emit('on-change-select', value)"
                >
                  <el-option
                    v-for="item in sizes"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <div class="input-group">
                    <span class="input-group-text">
                      <i class="fas fa-search"></i>
                    </span>

                    <input
                      v-model="filter"
                      class="form-control"
                      placeholder="Search"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- Table Content -->
            <div class="table-responsive p-0">
              <el-table
                :data="records"
                :key="records.id"
                :total="totalRecords"
                :loading="loading"
                style="width: 100%"
              >
                <el-table-column
                  v-for="{ name, label } in columnDefs.columns"
                  :prop="name"
                  :label="label"
                  :key="name"
                ></el-table-column>
                <el-table-column label="Actions">
                  <template #default="scope">
                    <div>
                      <el-tooltip
                        placement="top"
                        :content="config.allowEdit[1]"
                        v-if="config.allowEdit[0]"
                      >
                        <el-button
                          circle
                          type="warning"
                          size="small"
                          @click="$emit('on-edit-record', scope.row)"
                        >
                          <i class="fa fa-edit"></i>
                        </el-button>
                      </el-tooltip>

                      <el-tooltip
                        placement="top"
                        :content="config.allowDelete[1]"
                        v-if="config.allowDelete[0]"
                      >
                        <el-button
                          circle
                          type="danger"
                          size="small"
                          @click="$emit('on-delete-record', scope.row)"
                        >
                          <i class="fa fa-trash-o"></i>
                        </el-button>
                      </el-tooltip>

                      <slot name="extraButtons" :row="scope.row" />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="row">
              <div class="mt-2">
                <el-pagination
                  layout="prev, pager, next"
                  v-model:current-page="numberPage"
                  v-model:page-size="size"
                  :total="totalRecords"
                  :page-sizes="sizes"
                  @current-change="(value) => $emit('on-change-page', value)"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import ArgonButton from "@/components/ArgonButton.vue";

// defined JSON's
import { pageSizes as sizes } from "@/constants/parameters";

export default defineComponent({
  name: "DynamicTable",
  components: {
    ArgonButton,
  },
  props: {
    title: {
      type: String,
      default: "Default Title",
    },
    buttonTitle: {
      type: String,
      default: "Default Title",
    },
    queryString: {
      type: String,
      default: "",
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    columnDefs: {
      type: Object,
      required: true,
    },
    totalRecords: {
      type: Number,
      default: 0,
      required: true,
    },
    records: {
      type: Array,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    return {
      sizes,
      size: props.pageSize,
      filter: props.queryString,
      numberPage: props.pageNumber,
    };
  },
});
</script>
